/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SavePersonDocumentApprovalRequestViewModel } from "../types/SavePersonDocumentApprovalRequestViewModel.ts";

export const savePersonDocumentApprovalRequestViewModelSchema = z.object({
  firstName: z
    .string()
    .describe("Primeiro nome do aluno. Máximo de 200 caracteres. Opcional.")
    .nullish(),
  lastName: z
    .string()
    .describe("Sobrenome do aluno. Máximo de 200 caracteres. Opcional.")
    .nullish(),
  birthDateRG: z
    .string()
    .datetime()
    .describe("Data de nascimento. Opcional.")
    .nullish(),
  mothersName: z
    .string()
    .describe("Nome completo da mãe. Máximo de 200 caracteres. Opcional.")
    .nullish(),
  gender: z
    .number()
    .int()
    .describe(
      "Gênero. Opcional. Enum EGender: `1` = Male, `2` = Female, `3` = IDontWantToAnswer.",
    )
    .nullish(),
  nationalityId: z
    .number()
    .int()
    .describe("ID da nacionalidade. Opcional.")
    .nullish(),
  birthCountryId: z
    .number()
    .int()
    .describe(
      "ID do país de nascimento; 1 = Brasil (usa estado/cidade por ID e limpa os textos livres). Opcional.",
    )
    .nullish(),
  birthStateId: z
    .number()
    .int()
    .describe("ID do estado de nascimento (nascidos no Brasil). Opcional.")
    .nullish(),
  birthState: z
    .string()
    .describe(
      "Estado de nascimento em texto livre (nascidos no exterior). Máximo de 100 caracteres. Opcional.",
    )
    .nullish(),
  birthCityId: z
    .number()
    .int()
    .describe("ID da cidade de nascimento (nascidos no Brasil). Opcional.")
    .nullish(),
  birthCity: z
    .string()
    .describe(
      "Cidade de nascimento em texto livre (nascidos no exterior). Máximo de 100 caracteres. Opcional.",
    )
    .nullish(),
  idCountryNumber: z
    .string()
    .describe(
      "Número do documento de identidade estrangeiro. Máximo de 100 caracteres. Opcional.",
    )
    .nullish(),
  documentNumber: z
    .string()
    .describe("Número do RG. Máximo de 60 caracteres. Opcional.")
    .nullish(),
  dispatchRGOrg: z
    .string()
    .describe("Órgão expedidor do RG. Máximo de 30 caracteres. Opcional.")
    .nullish(),
  dispatchRGOrgState: z
    .string()
    .describe("UF do órgão expedidor do RG. Máximo de 2 caracteres. Opcional.")
    .nullish(),
  dispatchRGDate: z
    .string()
    .datetime()
    .describe("Data de expedição do RG. Opcional.")
    .nullish(),
  isForeignDegree: z
    .boolean()
    .describe(
      "Indica se o diploma de graduação foi emitido fora do Brasil; nulo preserva o valor atual. Opcional.",
    )
    .nullish(),
  foreignStatus: z
    .number()
    .int()
    .describe(
      "Situação do diploma estrangeiro; gravado apenas quando isForeignDegree = true. Opcional. Enum EForeignStatus: `1` = Approved, `2` = PendingDocument, `3` = EquivalenceMade, `4` = Cancelled.",
    )
    .nullish(),
  updateEnrollmentStatus: z.optional(
    z
      .boolean()
      .describe(
        "Define se o status da matrícula deve ser alterado para Aprovado após o salvamento (exige documentação geral Aprovada ou Aprovada Provisória).",
      ),
  ),
  documentAnalysisStartTimeTicks: z.optional(
    z
      .number()
      .int()
      .describe(
        "Início da análise em Ticks UTC, devolvido do GET do viewer, para o cálculo da duração no servidor.",
      ),
  ),
}) as unknown as ToZod<SavePersonDocumentApprovalRequestViewModel>;
